import { Link, useNavigate, useParams } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const DeliverySettlementDocument = () => {
  const { branchId, userId } = useParams();
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    userId: userId,
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  // const [posBalance, setPosBalance] = useState(0);
  // const [userPos, setUserPos] = useState(0);

  const getGridData = async () => {
    const resp = await apiMethod.getDeliveryInvoices(filterModel.branchId, filterModel.userId, 20, 1);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }

    // const resp1 = await apiMethod.getPosBalence(posId, 0);
    // if (methods.showApiErrors(resp1)) {
    //   setPosBalance(resp1.sum);
    // }

    // const resp2 = await apiMethod.getUserPos(branchId, userId, 100, 1);
    // if (methods.showApiErrors(resp2)) {
    //   setUserPos(resp2.data);
    // }
  };


  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    }
    bindData();
  }, [branchId, userId]);

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-flex justify-content-start align-items-baseline mb-3'>
              <Link to={`/sale/${branchId}/deliverySettlement/settlementOfAccounts/${userId}`} className='link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/deliverySettlement/settlementOfAccounts/${userId}`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                مدیریت پیک‌ها/ فاکتور های پیک/سندتسویه حساب
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>مدیریت پیک‌ها/ فاکتور های پیک/سندتسویه حساب</p>
            </div>
            <div className="salemain">
              {/* <div className='settlementDocument'>
                <p>نام پیک</p>
                <p>کد پرسنلی</p>
                <p>مبلغ کل فاکتورها (ریال)</p>
                <p>مابه تفاوت (ریال) </p>
              </div>
              <div className='settlementDocument'>
                <p className='col-12 col-lg-5'>مبلغ پوز (ریال)</p>
                <p className='col-12 col-lg-5'>انعام (ریال) </p>
              </div>
              <div className='d-flex justify-content-end'>
                <button
                  type="button"
                  className="btn custome-btn btn-link-purple ms-2"
                  onClick={() => navigate(`/sale/${branchId}/deliverySettlement/settlementOfAccounts/${userId}`)}
                >
                  انصراف
                </button>
                <button type="submit" className="btn custome-btn btn-purple">ثبت سند</button>
              </div> */}
              <div className='row g-3'>
                <div className="col-md-6 col-lg-3 text-center">
                  <div className='shadow p-3 text-4'>
                    <p>نام پیک</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3 text-center">
                  <div className='shadow p-3 text-4'>
                    <p>کد پرسنلی</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3 text-center">
                  <div className='shadow p-3 text-4'>
                    <p>مبلغ کل فاکتورها (ریال)</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3 rounded-4 text-center">
                  <div className='shadow p-3 text-4'>
                    <p>مابه تفاوت (ریال) </p>
                  </div>
                </div>
              </div>
              <div className='row g-3 my-5'>
                <div className="col-md-6 text-center">
                  <div className='shadow p-3 text-4'>
                    <p>مبلغ پوز (ریال)</p>
                    {/* <p>{posBalance}</p> */}
                  </div>
                </div>
                <div className="col-md-6 text-center">
                  <div className='shadow p-3 text-4'>
                    <p>انعام (ریال) </p>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-end'>
                <button
                  type="button"
                  className="btn custome-btn btn-link-purple ms-2"
                  onClick={() => navigate(`/sale/${branchId}/deliverySettlement/settlementOfAccounts/${userId}`)}
                >
                  انصراف
                </button>
                <button type="submit" className="btn custome-btn btn-purple">ثبت سند</button>
              </div>
            </div>
          </>
        }
      </>
    )
  };
  return (
    <>
      {renderItems()}
    </>
  );
}

export default DeliverySettlementDocument;